<div class="header">
    <h2 class="detail-header">Workflow component details: {{component().name}}</h2>
</div>

<hr class="full-width-tab-hr">

<workflow-configuration-detail-property-component [propertyMetadata]="propertyMetadata"></workflow-configuration-detail-property-component>
